import { useSelector } from 'react-redux';

import Global from '../store/global-selectors';
import { isNewLineupPlanProfileAndBillingPlan } from './feature-gate-helper';

/**
 *
 * @returns {{ isSellerOnFeatureGatedPlan: boolean}}
 */
export const useIsSellerOnFeatureGatedPlan = () => {
  return useSelector((state) => {
    const { planProfileId, billingPlanId } = Global.selectSellerSubscriptionPlanInfo(state) ?? {};
    return isNewLineupPlanProfileAndBillingPlan(planProfileId, billingPlanId);
  });
};
